const locale = require('./collaborationEmail.i18n.json');

/*@ngInject*/
const CollaborationEmailController = function ($scope, $sce, $uibModal, $timeout, $window,
                                               emailMessageStatus, loadingBarHandler,
                                               collaborationMediator, modalUtil,
                                               currentSubmissionModel, coreConstant, coreMediator,
                                               attachmentUtil, submissionConstant, collaborationUtil, emailMessage) {

    $scope.i18n = locale;
    $scope.emailTypePlaceholder = $scope.i18n.emailTypePlaceholder;
    $scope.userList = [];

    function resetEmailViewModel() {
        $scope.emailViewModel = {
            email: null,
            emailBody: '',
            typeDataItems: '',
            selectedEmailType: null
        };
    }

    function resetBusinessCardEmailViewModel() {
        $scope.businessCardEmailViewModel = {
            emailTo: null
        };
    }

    function loadCollaborationEmail(emailId) {
        $scope.viewModel.isLoading = true;

        collaborationMediator.loadCollaborationEmail(emailId).then(function (emailItem) {
            $scope.viewModel.isLoading = false;
            if ($scope.viewModel.selectedItem.isReplyOrForward) {
                $scope.emailViewModel.replyOrForwardEmail = emailItem;
            } else {
                resetEmailViewModel();
                $scope.emailViewModel.email = emailItem;

                $scope.emailViewModel.emailBody = $sce.trustAsHtml(emailItem.body);
                $scope.viewModel.email.isVisible = emailItem.status !== emailMessageStatus.STATUS_DRAFT && emailItem.origin !== 'UPLOAD';

                attachmentUtil.getAttachmentTypes().then(function (result) {
                    $scope.emailViewModel.typeDataItems = result;
                    $scope.emailViewModel.selectedEmailType = _.find(result, {name: emailItem.type});
                });

                // need to load users first to avoid duplicate loading
                coreMediator.loadUsersList(emailItem.submissionId).then(function() {
                    $scope.setToOrCcUsers($scope.emailViewModel.email, 'to');
                    $scope.setToOrCcUsers($scope.emailViewModel.email, 'cc');

                    if (emailItem.status === emailMessageStatus.STATUS_DRAFT && $scope.canCreateEmail()) {
                      $scope.expandEmail();
                    }
                });
            }

            if (emailItem.status === emailMessageStatus.STATUS_DRAFT && $scope.canCreateEmail()) {
                // Launch the pop-out editor for drafts.

                if ($scope.businessCardEmailViewModel.emailTo) {
                    // set email's 'to' for Send E-mail action from business card
                    $scope.emailViewModel.email.to = $scope.businessCardEmailViewModel.emailTo;
                }

                if ($scope.viewModel.selectedItem.isReplyOrForward) {
                    $scope.expandEmail();
                }
            }
        });
    }

    $scope.deleteEmail = function (email) {
        delete $scope.viewModel.selectedItem.deleteNewEmailOnCancel;
        loadingBarHandler.showLoadingBar('submission.collaboration.email.deletingEmail');
        collaborationMediator.deleteCollaborationEmail(email.id).then(function () {
            loadingBarHandler.hideLoadingBar();
        });
    };

    $scope.saveEmail = function (email, savedFromViewer) {
        let loadingBarMessageKey = 'submission.collaboration.email.';

        if (savedFromViewer) {
            $scope.emailViewModel.email = email;
            $scope.emailViewModel.selectedEmailType = _.find($scope.emailViewModel.typeDataItems, {name: email.type});
        }

        delete $scope.viewModel.selectedItem.deleteNewEmailOnCancel;
        loadingBarMessageKey += email.status === emailMessageStatus.STATUS_SENT ? 'savingEmail' : 'savingDraft';
        loadingBarHandler.showLoadingBar(loadingBarMessageKey);
        collaborationMediator.updateCollaborationEmail(email).then(function () {
            loadingBarHandler.hideLoadingBar();
        });
    };

    $scope.sendEmail = function (email) {
        delete $scope.viewModel.selectedItem.deleteNewEmailOnCancel;
        loadingBarHandler.showLoadingBar('submission.collaboration.email.sendingEmail');
        collaborationMediator.updateCollaborationEmail(email).then(function () {
            collaborationMediator.sendCollaborationEmail(email).then(function () {
                loadingBarHandler.hideLoadingBar();
            });
        });
    };

    $scope.canDeleteTheEmail = function () {
        let email = $scope.emailViewModel.email;
        let canDeleteTheEmail = false;
        if (email) {
            canDeleteTheEmail = $scope.isUnderwriterUser() && $scope.canDeleteEmail() &&
                (emailMessageStatus === emailMessageStatus.STATUS_DRAFT || email.origin === 'UPLOAD');
        }
        return canDeleteTheEmail;
    };

    $scope.onDeleteClick = function () {
        let config = {
            cancelButtonLabel: $scope.i18n.cancel,
            confirmActionButtonLabel: $scope.i18n.confirm,
            summary: $scope.i18n.deleteConfirmationMessage,
            title: $scope.i18n.deleteConfirmationTitle
        };

        modalUtil.showGenericConfirm(config).then(() => {
            let email = $scope.emailViewModel.email;
            $scope.deleteEmail(email);
            $scope.hideSubPage();
        });
    };

    $scope.onReplyClick = function () {
        let emailId = $scope.emailViewModel.email.id;
        $scope.replyEmail(emailId);
    };

    $scope.onReplyAllClick = function () {
        let emailId = $scope.emailViewModel.email.id;
        $scope.replyAllEmail(emailId);
    };

    $scope.onForwardClick = function () {
        let emailId = $scope.emailViewModel.email.id;
        $scope.forwardEmail(emailId);
    };

    $scope.replyEmail = function (emailId) {
        if (!emailId) {
            emailId = $scope.emailViewModel.email.id;
        }
        loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
        $scope.newEmailId = emailId;
        collaborationMediator.replyEmail(emailId);
    };

    $scope.replyAllEmail = function (emailId) {
        if (!emailId) {
            emailId = $scope.emailViewModel.email.id;
        }
        loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
        $scope.newEmailId = emailId;
        collaborationMediator.replyAllEmail(emailId);
    };

    $scope.forwardEmail = function (emailId) {
        if (!emailId) {
            emailId = $scope.emailViewModel.email.id;
        }
        loadingBarHandler.showLoadingBar('submission.collaboration.email.creatingForward');
        $scope.newEmailId = emailId;
        collaborationMediator.forwardEmail(emailId);
    };

    $scope.$on(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, function (event, payload) {
        if (payload.type === 'email' && $scope.newEmailId) {
            $timeout(function () {
                let submissionId = currentSubmissionModel.getCurrentSubmission().id;
                loadingBarHandler.hideLoadingBar();
                $scope.$emit(coreConstant.event.SHOW_EMAIL_EDITOR,
                             payload.id,
                             submissionId,
                             /*chatMessageId*/undefined,
                             /*emailMessageId*/undefined,
                             /*notificationId*/undefined,
                             /*deleteNewEmailOnCancel*/true,
                             /*isReplyOrForward*/true);
                $scope.newEmail = null;
            }, 50);
        }
    });

    $scope.expandEmail = function () {
        let expandedEmailModal,
            email = $scope.viewModel.selectedItem.isReplyOrForward ? $scope.emailViewModel.replyOrForwardEmail : $scope.emailViewModel.email;
        if (email.status === emailMessageStatus.STATUS_DRAFT) {
            if (_.isNull(email.to)) {
                email.to = '';
            }
            if (_.isNull(email.cc)) {
                email.cc = '';
            }
            if (_.isNull(email.bcc)) {
                email.bcc = '';
            }
            coreMediator.loadUsersList($scope.emailViewModel.email.submissionId).then(function (users) {
                expandedEmailModal = $uibModal.open({
                    templateUrl: '/collaboration/email/emailEditor/emailEditorModal.tpl.html',
                    controller: 'emailEditorModalController',
                    windowClass: 'emailEditorModal',
                    backdrop: 'static',
                    keyboard: 'false',
                    resolve: {
                        options: function () {
                            return {
                                email: email,
                                deleteEmail: $scope.deleteEmail,
                                saveEmail: $scope.saveEmail,
                                sendEmail: $scope.sendEmail,
                                deleteNewEmailOnCancel: $scope.viewModel.selectedItem.deleteNewEmailOnCancel,
                                canDeleteEmail: $scope.canDeleteEmail(),
                                userList: _.cloneDeep(users)
                            };
                        },
                        availableAttachments: function () {
                            return collaborationMediator.loadSubmissionAttachments(email.submissionId).then(function (submissionAttachmentList) {
                                return submissionAttachmentList;
                            });
                        }
                    }
                });

                function handleClose() {
                    if ($scope.viewModel.selectedItem.deleteNewEmailOnCancel) {
                        delete $scope.viewModel.selectedItem.isReplyOrForward;
                        delete $scope.emailViewModel.replyOrForwardEmail;
                        $scope.deleteEmail(email);
                        _.each($scope.viewModel.collabItemList, function (item) {
                            if (item.id === $scope.emailViewModel.email.id && item.type === 'email') {
                                $scope.selectItem(item);
                            }
                        });
                    }
                    if ($scope.emailViewModel.email.status === emailMessageStatus.STATUS_DRAFT || $scope.viewModel.selectedItem.isReplyOrForward) {
                        delete $scope.viewModel.selectedItem.isReplyOrForward;
                        delete $scope.emailViewModel.replyOrForwardEmail;
                        $scope.hideSubPage();
                    }
                }

                expandedEmailModal.result.finally(handleClose);
            });


        } else {
            email.toUsers = $scope.emailViewModel.toUsers;
            email.ccUsers = $scope.emailViewModel.ccUsers;
            expandedEmailModal = modalUtil.showEmailViewer(email, $scope.forwardEmail, $scope.replyEmail, $scope.replyAllEmail, $scope.saveEmail, $scope.deleteEmail,
                $scope.isUnderwriterUser(), $scope.canCreateEmail(), $scope.canDeleteEmail());

            function handleClose() {
                if ($scope.viewModel.selectedItem.deleteNewEmailOnCancel) {
                    delete $scope.viewModel.selectedItem.isReplyOrForward;
                    delete $scope.emailViewModel.replyOrForwardEmail;
                    $scope.deleteEmail(email);
                    _.each($scope.viewModel.collabItemList, function (item) {
                        if (item.id === $scope.emailViewModel.email.id && item.type === 'email') {
                            $scope.selectItem(item);
                        }
                    });
                }
                if ($scope.emailViewModel.email.status === emailMessageStatus.STATUS_DRAFT || $scope.viewModel.selectedItem.isReplyOrForward) {
                    delete $scope.viewModel.selectedItem.isReplyOrForward;
                    delete $scope.emailViewModel.replyOrForwardEmail;
                    $scope.hideSubPage();
                }
            }

            expandedEmailModal.result.finally(handleClose);
        }


    };

    $scope.isCurrentUser = function () {
        if ($scope.viewModel.userProfile && $scope.emailViewModel.email) {
            if ($scope.viewModel.userProfile.id === $scope.emailViewModel.email.fromUserId) {
                return true;
            }
        }
        return false;
    };

    $scope.getTitle = function () {
        if (!$scope.emailViewModel.email) {
            return false;
        }
        return $scope.emailViewModel.email.subject;
    };

    $scope.setToOrCcUsers = function (email, type) {

        let userArray = _.split((type === 'to') ? email.to : email.cc, emailMessage.EMAIL_ADDRESS_SEPERATOR),
            recipientList = [];
        coreMediator.loadUsersList(email.submissionId).then(function (users) {
            _.each(userArray, function (toUser) {
                let addedUser = false;
                _.each(users, function (user) {
                    let userString = collaborationUtil.getEmailIdentifierString(user.name, user.emailAddress);
                    if (toUser === userString) {
                        recipientList.push(user);
                        addedUser = true;
                    }
                });
                if (!addedUser) {
                    recipientList.push(toUser);
                }

            });
            if (type === 'to') {
                $scope.emailViewModel.toUsers = recipientList;
            } else {
                $scope.emailViewModel.ccUsers = recipientList;
            }
        });
    };

    $scope.onUpdateSelectedType = function () {
        let email = $scope.emailViewModel.email;

        if ($scope.emailViewModel.selectedEmailType) {
            email.type = $scope.emailViewModel.selectedEmailType.name;
        } else {
            email.type = null;
        }

        $scope.saveEmail(email);
    };

    $scope.onAttachmentDownloadClick = (attachment) => {
        attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then((url) => {
            $window.open(url, '_blank');
        });
    };

    $scope.$watch('viewModel.selectedItem', function (newItem) {

        if (newItem && newItem.isOpenedFromBusinessCard === true) {
            $scope.businessCardEmailViewModel.emailTo = newItem.summaryData.emailTo;
        }
        if (newItem && newItem.type === 'email') {
            loadCollaborationEmail(newItem.id);
        }
    });

    resetEmailViewModel();
    resetBusinessCardEmailViewModel();
};

angular.module('gw-um-submission')
    .controller('collaborationEmailController', CollaborationEmailController);
